// MockBrand AI Lab mock pack — EMPTY on purpose. MockBrand is the deterministic
// demo brand (apps/api/scripts/seed_mock_brand.py), opened by the demo code
// 0000 (user call 2026-11-02). The workspace session refuses a coded brand
// with no pack (contexts/SessionContext), so this pack exists to open the
// workspace: no scripted questions, no Weekly cards, so the Lab shows no
// chips and every ask takes the live path. Pure data, no imports.

export const MOCKBRAND_LAB = {
  brand: "mockbrand",
  name: "MockBrand",
  // the demo persona greeted on the Lab — every mock pack carries one
  person: "Alex",
  entries: [],
};
